import { useEffect } from 'react';

import { Navigate, useLocation } from 'react-router-dom';
import { toast } from 'sonner';

import { PATHS } from '@/constants/page-paths';
import { removeInvisibleElements } from '@/lib/utils/hide-elements';
import { useSettingsStore } from '@/store';

const AuthGuard = ({
  routeKey,
  children,
}: {
  routeKey: string;
  children: React.ReactNode;
}) => {
  const { settings } = useSettingsStore();
  const allowedPages = settings?.ui?.pages_sections?.pages;
  const allowedElements = settings?.ui?.pages_sections?.sections;
  const isAllowed =
    routeKey === undefined ||
    allowedPages?.[routeKey] === undefined ||
    allowedPages?.[routeKey] === true;

  const location = useLocation();

  useEffect(() => {
    removeInvisibleElements(allowedElements);
  }, [allowedElements, location]);

  useEffect(() => {
    if (!isAllowed) {
      toast.error('You are not allowed to access this page.', {
        description: 'Please contact your administrator for more information.',
      });
    }
  }, [isAllowed]);

  return isAllowed ? children : <Navigate to={PATHS.HOME} />;
};

export default AuthGuard;
